// extracted by css-extract-rspack-plugin
export default {"root":"zFwuTP","resolution":"WRf1ov","add-watermark-field":"h6_XgH","addWatermarkField":"h6_XgH"};